const csProjects = [
  {
    title: "The Humor Project",
    description: "Helped build the world's first funny AI. Users upload images and receive AI-generated funny captions.",
    image: "/assets/cs/crackd.svg",
    links: [
      { label: "Visit", url: "https://crackd.ai" }
    ]
  },
   {
    title: "Panem-et-Promptes",
    description: "A Retrieval-Augmented Generation Q&A system where users can ask natural language questions about The Hunger Games.",
    image: "/assets/cs/panem-et-promptes.png",
    links: [
      { label: "GitHub", url: "https://github.com/he-larious/panem-et-promptes" }
    ]
  },
  {
    title: "Flee the Factory",
    description: "An educational puzzle game teaching fundamental programming concepts such as functions, control flow, recursion, and data structures.",
    image: "/assets/cs/flee-factory.png",
    links: [
      { label: "GitHub", url: "https://github.com/The-Koopalings/Flee_The_Factory" }
    ]
  },
  {
    title: "Hero's Journey",
    description: "An interactive learning tool that teaches the 12 stages of the Hero's Journey and lets users create their own stories following the framework.",
    image: "/assets/cs/hero-journey.png",
    links: [
      { label: "GitHub", url: "https://github.com/he-larious/heros-journey" }
    ]
  },
];

export default csProjects;
